import { TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_3 } from '../../../../../config/tables'
import { TablaDetalleEspacioPorCerealLinea3Service } from '../../../../../models/movimiento/distribucionEspacioPorCereal/Tabla_detalle_espacio_por_cereal_linea_3'
import { COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_3, COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_3_TO_PRINT } from './constantesDetalleEspacioPorCerealLinea3'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_3
    })
    const promiseTablaDetalleEspacioPorCerealLinea3 = TablaDetalleEspacioPorCerealLinea3Service.getDataTablaDetalleEspacioPorCerealLinea3()
    const promiseTablaDetalleEspacioPorCerealLinea3Total = TablaDetalleEspacioPorCerealLinea3Service.getDataTablaDetalleEspacioPorCerealLinea3Total()
    Promise.all([promiseTablaDetalleEspacioPorCerealLinea3, promiseTablaDetalleEspacioPorCerealLinea3Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Espacio Por Cereal Sector 3',
        dataCombinada,
        COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_3_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_3,
          data: dataCombinada,
          title: `Espacio Por Cereal Sector 3`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_3
      })
    }
  }
}
